var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M11.5-7a.487.487,0,0,1,.359.141A.487.487,0,0,1,12-6.5v1a.487.487,0,0,1-.141.359A.487.487,0,0,1,11.5-5H7V-.5a.487.487,0,0,1-.141.359A.487.487,0,0,1,6.5,0h-1a.487.487,0,0,1-.359-.141A.487.487,0,0,1,5-.5V-5H.5a.487.487,0,0,1-.359-.141A.487.487,0,0,1,0-5.5v-1a.487.487,0,0,1,.141-.359A.487.487,0,0,1,.5-7H5v-4.5a.487.487,0,0,1,.141-.359A.487.487,0,0,1,5.5-12h1a.487.487,0,0,1,.359.141A.487.487,0,0,1,7-11.5V-7Z",
    transform: "translate(0 12)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8b8fd52f1fd93eb3ef5ec3719f29d169.svg";
export { ForwardRef as ReactComponent };